import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_MARKET_INFO_NAMESPACE = `${PARTNER360_NAMESPACE}/marketInfo`

export const REQUEST_PARTNER360_UPDATE_VERTICAL_MARKET_INFO = `${PARTNER360_MARKET_INFO_NAMESPACE}/updateVerticalMarketInfo`
export const REQUEST_PARTNER360_UPDATE_PARTNER_MARKET_INFO = `${PARTNER360_MARKET_INFO_NAMESPACE}/updatePartnerMarketInfo`
export const REQUEST_PARTNER_MARKET_LEASING = `${PARTNER360_MARKET_INFO_NAMESPACE}/requestPartnerMarketLeasing`
export const REQUEST_CHANGE_PARTNER_MARKET_LEASING = `${PARTNER360_MARKET_INFO_NAMESPACE}/changePartnerMarketLeasing`
